import $ from 'jquery';

const selectors = {
	page: '.js-invest',
	docs: '.js-invest-docs',
	select: {
		el: '.js-select',
		input: '.js-select-input'
	}
};

const states = {
	docs: {
		visible: 'invest__docs_state_visible'
	}
};

const $page = $(selectors.page);

const toggleList = year => {
	const visibleClass = states.docs.visible;
	const $activeDocs = $(`.${visibleClass}`);
	const $targetDocs = $(selectors.docs).filter(`[data-year=${year}]`);
	if (!$targetDocs.length || $targetDocs.hasClass(visibleClass)) {
		return;
	}
	$activeDocs.removeClass(visibleClass);
	$targetDocs.addClass(visibleClass);
};

const onSelect = e => {
	const $target = $(e.target);
	const $input = $target.find(selectors.select.input);
	const year = $input.val();
	toggleList(year);
};

const setHandlers = () => {
	const $select = $page.find(selectors.select.el);
	$select.on('select', onSelect);
};

const render = () => {
	if ($page.length) {
		setHandlers();
	}
};

export default render;



/** WEBPACK FOOTER **
 ** ./app/blocks/invest/index.js
 **/